import { findIncluded } from '@/utils/finder';

export function extractData(that) {
  if (that.data) {
    return extractData(that.data)
  } else {
    return that
  }
};

export function extractDATA(response) {
  if (response.data) {
    return extractDATA(response.data)
  } else {
    return response
  }
};

export function extractJWT(headers) {
  return {
    'client': headers['client'],
    'uid': headers['uid'],
    'expiry': headers['expiry'],
    'access-token': headers['access-token'],
    'token-type': headers['token-type'],
    'token': headers['access-token']
  }
};


export function assignObj(that) {
  let rel = {}
  if (that.relationships) {
    let keys = Object.keys(that.relationships)
    for (let i = 0; i < keys.length; i++) {
      rel[keys[i]] = []
      // console.log("###", keys[i], that.relationships[keys[i]].data)
      for (let ii = 0; ii < that.relationships[keys[i]].data.length; ii++) {
        // console.log("***", keys[i], that.relationships[keys[i]].data, that.relationships[keys[i]].data[ii])
        rel[keys[i]].push(that.relationships[keys[i]].data[ii].id)
      }
    }
  }
  return Object.assign({ id: that.id, type: that.type }, that.attributes, rel);
};

export function assignObjNested(that) {
  // log.info( "assignObjNested", that )
  if (that.data && that.data.relationships && that.included) {
    let rel = {}
    let keys = Object.keys(that.data.relationships)
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i]
      let val = that.data.relationships[key].data
      if (Array.isArray(val)) {
        rel[key] = []
        for (let ii = 0; ii < val.length; ii++) {
          rel[key].push(assignObjNested(findIncluded(that.included, val[ii])))
        }
      } else {
        rel[key] = assignObjNested(findIncluded(that.included, val))
      }
    }
    return Object.assign({ id: that.data.id, type: that.data.type }, that.data.attributes, rel);
  } else {
    return Object.assign({ id: that.id, type: that.type }, that.attributes);
  }
};

export function assignCollection(data) {
  // state.projects = payload.data
  let collection = []
  if (data && data.length) {
    for (let i = 0; i < data.length; i++) {
      collection.push(assignObj(data[i]))
    }
  }
  return collection;
};


export function assignResponse(that) {
  // log.debug("assignResponse", that)
  let data = extractData(that)
  // log.debug("assignResponse", data)
  if (typeof (data.length) === 'number') {
    return assignCollection(data)
  } else {
    return assignObj(data)
  }
};


export function shuffleCollection(collection) {
  // https://stackoverflow.com/a/6274398
  let array = collection;
  let counter = array.length;
  // While there are elements in the array
  while (counter > 0) {
    // Pick a random index
    let index = Math.floor(Math.random() * counter);
    // Decrease counter by 1
    counter--;
    // And swap the last element with it
    let temp = array[counter];
    array[counter] = array[index];
    array[index] = temp;
  }
  return array;
};


